import React from 'react';
import Table from '../Table';

const MemberTableSkeleton: React.FC = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: 'User',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-36 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
      {
        Header: 'Email',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-36 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
      {
        Header: 'Phone Number',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-28 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
      {
        Header: 'Role',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-20 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
      {
        Header: 'Status',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-20 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
      {
        id: 'edit',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-16 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
    ],
    []
  );

  const data = new Array(6).fill('');

  return <Table columns={columns} data={data} />;
};

export default MemberTableSkeleton;
